import React from 'react'

import BlockContent from "@sanity/block-content-to-react"

import { Serializer } from "src/utils/serializer"
import { Image } from 'src/components/image'
import { ProductForm } from './form'

export const ProductHero = ({ product, main: { title, productDescription, linkedCollection, linkedSite, linkedSiteName, mainImage }}: {
  main: {
    title?: string
    subTitle?: string
    slug: {}
    productDescription?: []
    mainImage: {
      asset: {
        _id: string
      }
    }
    linkedSite: string
    linkedSiteName: string
    cerealImage: {}
  }
  product: {
    defaultPrice: string
    productId: number
  }
}) => {
  return (
    <div className='product__hero'>
      <div className='container--xl p1 outer mxa'>
        <div className='f fw jcb aist'>
          <div className='c50 x'>
            <Image className='x' imageId={mainImage.asset._id} alt={title} />
          </div>
          <div className='c50 container--s mxa'>
            <div>
              {linkedCollection && (
                <span className='caps h4 m0 p0'>/{linkedCollection.content.main.title}</span>
              )}
              <h1 className='caps mt0 pt0'>{title}</h1>
            </div>

            <div className='caps my1 py1'>
              {productDescription && (<BlockContent blocks={productDescription} serializers={Serializer} />)}
            </div>
            {linkedSite && linkedSiteName && (
              <div className='callout bcblue cw p1 my1'>
                Shop the real product on the <a href={linkedSite} className='cw underline' target='_blank'>{linkedSiteName}</a> Website.
              </div>
            )}
            <ProductForm {...product} showQuantity={true} />
          </div>
        </div>
      </div>
    </div>
  )
}